module.exports = __webpack_public_path__ + "static/media/Icon-CV_Set 1_Pro.1f9a72fc.svg";